import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Button, Checkbox, Col, Form, message, Modal, Row, Spin, Table } from "antd";
import { uniqBy } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ReactComponent as Edit } from "../assets/Edit_Pencil_01.svg";

import COLORS from "common/Colors";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import EmployeeRoleChangeModal from "../reusableComponent/EmployeeRoleChangeModal";
import NewRolesAndPermissions from "../../src/pages/NewRolesAndPermissions";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { getClientid, getLocations } from "redux/selectors";
import { setUserList } from "redux/actions";
import { EditOutlined } from "@mui/icons-material";

const DetailsWrapper = styled.div`
  .change-view {
    color: #2d53da;
    border-radius: 10px;
  }
  .change-view:disabled {
    color: #e3e8fc !important;
  }
  .change-view:hover {
    background: #c5cff5;
  }
  .underline-btn {
    text-decoration: underline !important;
  }
`;

const StyledTable = styled(Table)`
  table {
    table-layout: auto !important;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 10px;
    height: 50px !important;
    border: none;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 8px;
    cursor: pointer;
  }
  .action-icons {
    display: none;
    cursor: pointer;
  }
`;

const actionButtonStyle = {
    color: "#fff !important",
    backgroundColor: "#00685F",
    borderColor: "#00685F",
    paddingInline: "12px",
    borderRadius: "5px",
};

const StyledButton = styled(Button)`
  color: white;
  background-color: #00685F;
  border-radius: 5px;
  margin-left: 5%;
  border-color: #00685F;
  color: #ffffff !important;
  &:hover,&:focus {   background-color: #00685F;
  border-color: #00685F;
  color: #ffffff !important;
  
  }

`;
const CancelButton = styled(Button)`
  background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;

  &:hover,
  &:focus,
  &:active {
    background: #ffffff !important;
  border-color: #000000 !important;
  color: #000000 !important;
  }
`;
const StyledActionButton = styled(Button)`
  color: #00685F !important;
  background-color: #deefee;
  border-color: #deefee;
  border-radius: 5px;
  margin-left: 5%;
  &:hover,
  &:focus,
  &:active,
  &.active {
    color: #00685F !important;
  background-color: #deefee;
  border-color: #deefee;
  }
`;

const RoleDetails = ({
    details,
    menuList = [],
    setMenuList,
    saveMenuList,
    MenuList,
    selectedRoleId,
    viewOnly = false,
    toggleEditRole,
    getRoleList,
}) => {
    const clientId = useSelector(getClientid);
    const locationList = useSelector(getLocations);

    const [form] = Form.useForm();
    const [employeeList, setEmployeeList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bulkMode, setBulkMode] = useState(false);
    const [roleChangePopup, setRoleChangePopup] = useState(false);
    const [roleChangeUserId, setRoleChangeUserId] = useState("");
    const [roleData, setRoleData] = useState("");
    const [isView, setIsView] = useState(false);
    const [isEditPermission, setIsEditPermission] = useState(false);
    const [isCustomPermission, setIsCustomPermission] = useState(false);
    const [editRecord, setEditRecord] = useState({});
    const [showRevertConfirm, setShowRevertConfirm] = useState(false);
    const [editMenuList, setEditMenuList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        fetchEmployeeDetails();
    }, []);

    const fetchEmployeeDetails = async () => {
        try {
            setLoading(true);
            const response = await CALL_FEATCH_API(
                `get-users-by-role/${clientId}/${selectedRoleId}`,
                "get"
            );
            setEmployeeList(response?.response?.response || []);
            setFilteredList(response?.response?.response || []);
        } catch (error) {
            message.error("Failed to fetch employee details");
            setEmployeeList([]);
            setFilteredList([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchMasterData = async () => {
        const { code, userList } = await CALL_API(`master-data/${clientId}`, "post", {
            fetch_master_data: true,
        });

        if (code === "SUCCESS" && userList) {
            dispatch(setUserList(userList));
        }
    };

    const handleFormChange = () => {
        const values = form.getFieldsValue();
        const { name = [], country = [] } = values;

        let result = isCustomPermission
            ? employeeList.filter((emp) => emp?.custompermission)
            : [...employeeList];

        if (name?.length > 0) {
            result = result.filter((emp) => name.includes(emp.userid));
        }
        if (country?.length > 0) {
            result = result.filter((emp) => country.includes(emp.managingoffice?.[0]));
        }

        setFilteredList(result);
    };

    const handleChangeRole = (e, record) => {
        e.stopPropagation();
        setRoleChangeUserId(record.userid);
        setRoleChangePopup(true);
        setRoleData(record);
    };

    const handleEditClick = async (e, record) => {
        e.stopPropagation();
        setRoleChangeUserId(record.userid);
        setIsEditPermission(true);

        try {
            setLoading(true);
            const response = await CALL_FEATCH_API(
                `get-users-by-role/${clientId}/${selectedRoleId}?userid=${record.userid}`,
                "get"
            );

            let data = response?.response?.response;

            if (!Array.isArray(data)) {
                data = data ? [data] : [];
            }

            const fetchedRecord = data[0] || record;
            setEditRecord(fetchedRecord);

            const userMenulist = fetchedRecord?.menulist?.[String(selectedRoleId)] || [];
            setEditMenuList(userMenulist);

            // ✅ Don't override employeeList and filteredList

        } catch (error) {
            message.error("Failed to fetch employee details");
            setEditRecord(record);
            setEditMenuList([]);
        } finally {
            setLoading(false);
        }
    };

    const handleClickBack = () => {
        getRoleList();
        toggleEditRole(false);
    };

    const handleRevertConfirm = async () => {
        await onFinish({
            type: "default",
            userIds: selectedRowKeys.filter(Boolean),
        });
        setShowRevertConfirm(false);
    };

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const payload = {
                role_id: selectedRoleId || "",
                userIds:
                    bulkMode || values?.type === "default"
                        ? selectedRowKeys.filter(Boolean)
                        : [roleChangeUserId].filter(Boolean),
                type: values?.type || "custom",
            };
            if (payload.type === "custom") {
                payload.menulist = {
                    [String(selectedRoleId ?? "")]: values,
                };
            }
            const response = await CALL_FEATCH_API(
                `change-custom-permission/${clientId}`,
                "post",
                payload
            );
            if (response?.status === 200) {
                message.success("Permissions updated successfully!");
                setIsCustomPermission(false);
                setIsEditPermission(false);
                setIsView(false);
                setRoleChangePopup(false);
                fetchEmployeeDetails();
                fetchMasterData();
                setSelectedRowKeys([]);
            } else {
                message.error(response?.message || "Failed to update permissions");
            }
        } catch {
            message.error("Something went wrong while updating permissions");
        } finally {
            setLoading(false);
        }
    };

    const uniqueName = uniqBy(
        (isCustomPermission
            ? employeeList.filter((emp) => emp?.custompermission)
            : employeeList
        ).map((emp) => ({
            label: emp.fullname,
            value: emp.userid,
        })),
        "value"
    );

    const uniqueCountryName = uniqBy(
        (isCustomPermission
            ? employeeList.filter((emp) => emp?.custompermission)
            : employeeList
        )
            .map((emp) => ({
                label: emp.managingoffice?.[0] || "-",
                value: emp.managingoffice?.[0] || "-",
            }))
            .filter((c) => c.value !== "-"),
        "value"
    );

    const baseColumns = [
        {
            title: "Name",
            dataIndex: "fullname",
            key: "fullname",
            render: (text, record) => (
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    {!isCustomPermission && record.custompermission && (
                        <span
                            style={{
                                display: "inline-block",
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                backgroundColor: "red",
                            }}
                        />
                    )}
                    {text}
                </span>
            ),
        },
        { title: "Employee ID", dataIndex: "employeeid", key: "employeeid" },
        { title: "Job Title", dataIndex: "jobtitle", key: "jobtitle" },
        {
            title: "Country",
            dataIndex: "managingoffice",
            key: "managingoffice",
            render: (val) => val?.[0] || "-",
        },
    ];

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allUserIds = filteredList.map((emp) => emp.userid);
            setSelectedRowKeys(allUserIds);
        } else {
            setSelectedRowKeys([]);
        }
    };

    const actionColumn = {
        title: bulkMode ? (
            <Checkbox
                checked={
                    selectedRowKeys.length === filteredList.length &&
                    filteredList.length > 0
                }
                indeterminate={
                    selectedRowKeys.length > 0 &&
                    selectedRowKeys.length < filteredList.length
                }
                onChange={handleSelectAll}
            >
                Select All
            </Checkbox>
        ) : (
            "Actions"
        ),
        key: "actions",
        align: "center",
        width: "25%",
        render: (_, record) =>
            bulkMode ? (
                <Checkbox
                    checked={selectedRowKeys.includes(record.userid)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        setSelectedRowKeys((prev) =>
                            e.target.checked
                                ? [...prev, record.userid]
                                : prev.filter((id) => id !== record.userid)
                        );
                    }}
                />
            ) : (
                <div className="action-icons">
                    <StyledActionButton
                        // style={actionButtonStyle}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleChangeRole(e, record);
                        }}
                    >
                        Change Role
                    </StyledActionButton>
                    <EditOutlined
                        // style={actionButtonStyle}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(e, record);
                        }}
                        style={{
                            color: "#00685F",
                            cursor: "pointer",
                            background: "#deefee",
                            padding: "2px",
                            borderRadius: "4px",
                            height: "32px",
                            width: "28px",
                            fontSize: 18
                        }}
                    >
                        Edit
                    </EditOutlined>
                </div>
            ),
    };

    const columns = isCustomPermission
        ? baseColumns
        : [...baseColumns, actionColumn];

    const handleRowClick = async (record) => {
        setRoleChangeUserId(record.userid);
        setIsView(true);

        try {
            setLoading(true);
            const response = await CALL_FEATCH_API(
                `get-users-by-role/${clientId}/${selectedRoleId}?userid=${record.userid}`,
                "get"
            );

            let data = response?.response?.response;

            // Convert non-array response to array
            if (!Array.isArray(data)) {
                data = data ? [data] : [];
            }

            // Set the record with the fetched data
            const fetchedRecord = data[0] || record;
            setEditRecord(fetchedRecord);

            // Extract menulist from the API response
            const userMenulist = fetchedRecord?.menulist?.[String(selectedRoleId)] || [];
            setEditMenuList(userMenulist);

        } catch (error) {
            message.error("Failed to fetch employee details");
            setEditRecord(record); // Fallback to original record
            setEditMenuList([]); // Empty menulist on error
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        form.resetFields();
        handleFormChange();
    }, [isCustomPermission]);

    return (
        <DetailsWrapper>
            <Spin spinning={loading}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <label
                            className="bg-transparent border-0 mb-3 text-left styled-cursor"
                            onClick={handleClickBack}
                        >
                            Role - Permission <ArrowForwardIosIcon className="px-1" />
                        </label>

                        {(isCustomPermission || isView || isEditPermission) && (
                            <label
                                className="bg-transparent border-0 mb-3 text-left styled-cursor"
                                onClick={() => {
                                    setIsEditPermission(false);
                                    setIsView(false);
                                    setIsCustomPermission(false);
                                    setSelectedRowKeys([]);
                                    setEditMenuList([]);
                                    setEditRecord({});
                                    // ✅ Refetch all employees to restore full list
                                    fetchEmployeeDetails();
                                }}
                            >
                                {details?.roleName} <ArrowForwardIosIcon className="px-1" />
                            </label>
                        )}
                        <b>
                            {isCustomPermission
                                ? "Custom Permission"
                                : isView
                                    ? editRecord?.fullname
                                    : isEditPermission
                                        ? "Editing Permission"
                                        : details?.roleName}
                        </b>
                    </div>
                    {!isCustomPermission && !isView && !isEditPermission && !bulkMode && (
                        <StyledButton
                            type="link"
                            className="change-view"
                            // style={actionButtonStyle}
                            onClick={() => {
                                setBulkMode(false);
                                setIsCustomPermission(true);
                                setIsEditPermission(false);
                                setIsView(false);
                            }}
                        >
                            Custom Permission
                        </StyledButton>
                    )}
                </div>
                {!isEditPermission && !isView && (
                    <>
                        <Form
                            form={form}
                            layout="vertical"
                            className="mt-2"
                            onValuesChange={handleFormChange}
                        >
                            <Row align="middle" justify="space-between" gutter={16}>
                                <Col flex="none">
                                    <label>
                                        {selectedRowKeys?.length > 0
                                            ? `Selected Employees: ${selectedRowKeys?.length}`
                                            : `Total Employees: ${filteredList?.length}`
                                        }
                                    </label>
                                </Col>

                                <Col flex="auto">
                                    <Row gutter={12} justify="end" align="center ">
                                        <Col>
                                            <DropdownCheckBox
                                                name="name"
                                                label="People"
                                                options={uniqueName}
                                                form={form}
                                                handleFormChange={handleFormChange}
                                            />
                                        </Col>
                                        <Col>
                                            <DropdownCheckBox
                                                name="country"
                                                label="Country"
                                                options={uniqueCountryName}
                                                form={form}
                                                handleFormChange={handleFormChange}
                                            />
                                        </Col>
                                        <Col>
                                            <Button
                                                type="link"
                                                disabled={isCustomPermission}
                                                className="underline-btn"
                                                onClick={() => setBulkMode(!bulkMode)}
                                            >
                                                Bulk Role Change
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>

                        <StyledTable
                            dataSource={filteredList}
                            columns={columns}
                            rowKey="userid"
                            pagination={false}
                            rowSelection={
                                isCustomPermission
                                    ? { selectedRowKeys, onChange: setSelectedRowKeys }
                                    : null
                            }
                            onRow={(record) => {
                                if (!isCustomPermission) {
                                    return {
                                        onClick: () => handleRowClick(record), // ✅ Use the new function
                                    };
                                }
                                return {};
                            }}
                        />

                        {(isCustomPermission && selectedRowKeys?.length > 0) && (
                            <div className="d-flex justify-content-end mt-3">
                                <StyledButton
                                    // style={actionButtonStyle}
                                    disabled={selectedRowKeys?.length === 0}
                                    onClick={() => setShowRevertConfirm(true)}
                                >
                                    Revert To Default Permission
                                </StyledButton>
                            </div>
                        )}
                        {(bulkMode && selectedRowKeys?.length > 0) && (
                            <div className="d-flex justify-content-end mt-3">
                                <CancelButton
                                    type="link"
                                    // style={actionButtonStyle}
                                    onClick={() => {
                                        setBulkMode(false);
                                        setSelectedRowKeys([]);
                                    }}
                                >
                                    Cancel
                                </CancelButton>
                                <StyledButton
                                    type="link"
                                    // style={actionButtonStyle}
                                    disabled={selectedRowKeys?.length === 0}
                                    onClick={() => setRoleChangePopup(true)}
                                >
                                    Next
                                </StyledButton>
                            </div>
                        )}
                        {roleChangePopup && (
                            <EmployeeRoleChangeModal
                                open={roleChangePopup}
                                onClose={() => setRoleChangePopup(false)}
                                oldRoleId={selectedRoleId}
                                userIds={
                                    bulkMode
                                        ? selectedRowKeys.filter(Boolean)
                                        : [roleChangeUserId].filter(Boolean)
                                }
                                roleData={roleData}
                                fetchEmployeeDetails={fetchEmployeeDetails}
                                setParentLoading={setLoading}
                            />
                        )}
                    </>
                )}

                {(isView || isEditPermission) && (
                    <NewRolesAndPermissions
                        viewOnly={isView}
                        menuList={editMenuList}
                        type={isEditPermission ? "employee-edit" : "view"}
                        onBack={() => {
                            setIsView(false);
                            setIsEditPermission(false);
                            setEditMenuList([]); // ✅ Clear menulist
                            fetchEmployeeDetails(); // ✅ Refresh the list
                        }}
                        onFinish={onFinish}
                        loading={loading}
                        setIsView={setIsView}
                        setIsEditPermission={setIsEditPermission}
                        setMenuList={setMenuList}
                        saveMenuList={saveMenuList}
                        MenuList={MenuList}
                        handleCancel={() => {
                            setIsView(false);
                            setIsEditPermission(false);
                            setEditMenuList([]); // ✅ Clear menulist
                        }}
                    />
                )}

                <Modal
                    open={showRevertConfirm}
                    onCancel={() => setShowRevertConfirm(false)}
                    centered
                    footer={null}
                    bodyStyle={{ textAlign: "center", borderRadius: "12px" }}
                    style={{ borderRadius: "12px" }}
                >
                    <p style={{ marginBottom: 24 }}>
                        Are you sure you want to revert the permissions to the default permission
                        setup of the role <b>{details?.roleName}</b>?
                    </p>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px" }}>
                        <Button
                            key="no"
                            onClick={() => setShowRevertConfirm(false)}
                            style={{
                                border: "1px solid #000",
                                color: "#000",
                                background: "#fff",
                                borderRadius: "8px",
                                width: "80px",
                            }}
                        >
                            No
                        </Button>
                        <StyledButton
                            key="yes"
                            // type="primary"
                            loading={loading}
                            onClick={handleRevertConfirm}
                            style={{
                                background: "#00685F",
                                borderColor: "#00685F",
                                borderRadius: "8px",
                                width: "80px",
                            }}
                        >
                            Yes
                        </StyledButton>
                    </div>
                </Modal>
            </Spin>
        </DetailsWrapper>
    );
};

export default RoleDetails;